import { TagCategory } from '@exam-center/graphql';
import { parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs';

const tagCategories: TagCategory[] = [TagCategory.Part, TagCategory.Subject];

export function useExamEventScoreReportSearchParams() {
  const [{ examCourseId, examCourseLabel, tagCategory }, setQueryParams] = useQueryStates({
    examCourseId: parseAsString.withDefault(''),
    examCourseLabel: parseAsString.withDefault(''),
    tagCategory: parseAsStringEnum<TagCategory>(tagCategories),
  });

  const changeExamCourse = ({
    examCourseId,
    examCourseLabel,
  }: {
    examCourseId: string;
    examCourseLabel: string;
  }) => {
    setQueryParams({ examCourseId, examCourseLabel });
  };

  const changeTagCategory = (tagCategory: TagCategory | null) => {
    setQueryParams({ tagCategory });
  };

  const resetFilters = () => {
    setQueryParams({
      examCourseId: '',
      examCourseLabel: '',
      tagCategory: null,
    });
  };

  return [
    {
      examCourseId,
      examCourseLabel,
      tagCategory,
    },
    {
      changeExamCourse,
      changeTagCategory,
      resetFilters,
    },
  ] as const;
}
